'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/ingredient-nav');

(0, _themeSections.load)(['ingredient-nav']);